// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3Wwux","errorLogs":"styles_errorLogs__3psCQ"};